module.exports = __webpack_public_path__ + "img/audio-mark6.25ba28be.png";